module.exports = __webpack_public_path__ + "static/media/champagnefm.971f697e.png";